import script from "./CompanyEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyEditModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyEditModal.vue?vue&type=style&index=0&id=d2e13280&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2e13280"]])

export default __exports__